import {
  ClipboardIcon,
  DocumentDuplicateIcon,
  TrashIcon
} from "@heroicons/react/24/outline";
import imageCompression from "browser-image-compression";
import { AnimatePresence, motion } from "framer-motion";
import * as pdfjsLib from "pdfjs-dist/webpack";
import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp, FaPlus } from "react-icons/fa";
import { TailSpin } from 'react-loader-spinner';
import Stepper from "react-stepper-horizontal"; // Import Stepper
import useApiFetcher from "../../../hooks/useApiFetcher";
import styles from "./StepperForm.module.css";
import TableComponent from "./TableComponent";

import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { GrFormPrevious } from "react-icons/gr";
import { MdDelete, MdNavigateNext } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { updatemultiStepProcessId } from "../../../Redux/authSlice";
import { savemultiStepProcessId } from "../../Avatar/Utility";
import { useNavigate, useSearchParams } from "react-router-dom";

const categories = [
  "Intro",
  "Product Script",
  "Summary Script",
  "Final Script",
];

const StepperForm = () => {
  const [searchParams] = useSearchParams();

  const dealershipId = searchParams.get('dealershipId');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { apiFetcher } = useApiFetcher();
  const [currentStep, setCurrentStep] = useState(1);
  const [steps, setSteps] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [promptInput, setPromptInput] = useState("");
  const [tableIndex, setTableIndex] = useState(null);
  const [selectedSentence, setSelectedSentence] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [resp, setResp] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [editing, Setediting] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(null);
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedDealer, setSelectedDealer] = useState(dealershipId);
  const [formData, setFormData] = useState({
    selectedSentence: selectedSentence,
    heading: "",
    subHeading: "",
    content: "",
    category: "",
    isButton: false,
    buttonText: "",
    images: [
      {
        imgTitle: "",
        image: null,
      },
    ],
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [originalStepData, setOriginalStepData] = useState(null);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    index: null,
  });
  const handleInputChange = (e) => {
    setPromptInput(e.target.value); // Update the promptInput state with the new value
  };
  const dealId = searchParams.get('multiStepProcessId');
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await apiFetcher(`/int-multi-stepper/${dealId}`, "GET");
        if (response) {
          setSelectedDealer(response?.dealershipId)

          const newSteps = response.steps.map((step, index) => {
            const script = step.script || "";
            setPromptInput(step.aiPrompt)
            const otherdata = {
              category: step.type,
              number: index + 1,
              script: step.script || "",
              submitted: true,
              title: step.stepTitle || `Step ${index + 1}`,
              price: step.price,
              buttonText: step.buttonText
            }
            const newSentences = splitSentences(script)
              .filter((sentence) => sentence.trim() !== "")
              .map((sentence) => {
                const matchedNotepadContent = step.notepadContents?.find((notepad) =>
                  notepad.key.trim() === sentence.trim()
                )

                return {
                  sentence: sentence.trim(),
                  notepadData: {
                    selectedSentence: matchedNotepadContent?.key || "",
                    heading: matchedNotepadContent?.heading || "",
                    subHeading: matchedNotepadContent?.subHeading || "",
                    content: matchedNotepadContent?.sentence || "",
                    category: matchedNotepadContent?.category || "",
                    isButton: matchedNotepadContent?.isButton || false,
                    buttonText: matchedNotepadContent?.buttonText || "",
                    unselectionScrip: matchedNotepadContent?.unselectionScrip || "",
                    reselectionScrip: matchedNotepadContent?.reselectionScrip || "",
                    images: matchedNotepadContent?.images?.map(({ text, image }) => ({
                      imgTitle: text || "",
                      image: image || null,
                    })) || [],
                  },
                  boardDataAdded: matchedNotepadContent?.boardDataAdded || false
                };
              });

            return {
              boardData: newSentences,
              ...otherdata
            };
          });
          setResp(response)
          setSteps(newSteps);
          setPromptInput(response.aiPrompt || "");
        }
      } catch (error) {
        console.error("Error fetching saved data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    if (dealId?.length) {

      fetchData();
    }
  }, [dealId]);

  useEffect(() => {
    setPromptInput(resp.aiPrompt || "");
  }, [currentStep]);

  useEffect(() => {
    setFormData((prevformdata) => {
      return {
        ...prevformdata,
        selectedSentence: selectedSentence,
      };
    });
  }, [selectedSentence]);

  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => setCurrentStep((prev) => prev - 1);

  useEffect(() => {
    window.addEventListener("beforeunload", handleWindowClose);
    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, []);

  const handleWindowClose = (event) => {
    console.log("User is trying to refresh or close the window");
    event.preventDefault();
  };

  const [isShowNext, setIsShowNext] = useState(false);

  const handleImageChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);

      const formData2 = new FormData();
      formData2.append("image", compressedFile);

      const presignedUrl = await apiFetcher("/multi-stepper/upload", "POST", { key: 'test' });
      const uploadResponse = await axios.put(presignedUrl, compressedFile, {
        headers: {
          "Content-Type": 'multipart/form-data',
        },
      });

      const objectViewUrl = presignedUrl.split('?X-Amz-Algorithm')[0];

    } catch (error) {
      console.error("Error compressing or uploading image:", error);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      extractTextFromPDF(file);
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      extractTextFromPDF(file);
    } else {
      alert("Only PDF files are allowed.");
    }
  };

  const handleCopyAllData = () => {
    const dataToCopy = {
      steps,
      promptInput,
    };
    const jsonString = JSON.stringify(dataToCopy, null, 2);
    navigator.clipboard
      .writeText(jsonString)
      .then(() => {
        alert("All data copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy data:", err);
        alert("Failed to copy data to clipboard.");
      });
  };

  const handlePasteData = () => {
    navigator.clipboard
      .readText()
      .then((text) => {
        try {
          const pastedData = JSON.parse(text);
          if (pastedData.steps && Array.isArray(pastedData.steps) && typeof pastedData.promptInput === "string") {
            setSteps(pastedData.steps);
            setPromptInput(pastedData.promptInput);
            alert("Data pasted successfully!");
          } else {
            alert("Invalid data format in clipboard. Please copy valid StepperForm data.");
          }
        } catch (err) {
          console.error("Failed to parse pasted data:", err);
          alert("Failed to parse clipboard data. Please ensure valid JSON data is copied.");
        }
      })
      .catch((err) => {
        console.error("Failed to read clipboard:", err);
        alert("Failed to read clipboard data.");
      });
  };

  const extractTextFromPDF = async (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument(typedArray).promise;
      let extractedText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map((item) => item.str).join(" ");
        extractedText += pageText + "\n";
      }
      setPromptInput((prev) => prev ? `${prev}\n${extractedText}` : extractedText);
    };
  };

  const handleAddAccordion = () => {
    Setediting(false);
    setEditingIndex(null);
    setOriginalStepData(null);
    setSteps((prev) => [
      ...prev,
      {
        number: prev.length + 1,
        title: "",
        script: "",
        placeholder: "Enter step title",
        submitted: false,
        boardData: [],
      },
    ]);
  };

  useEffect(() => {
    if (steps.length === 0) {
      setIsShowNext(false);
    } else {
      setIsShowNext(true);
    }
  }, [steps]);

  const handleToggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleTitleChange = (index, value) => {
    setSteps((prev) =>
      prev.map((step, i) => (i === index ? { ...step, title: value } : step))
    );
  };

  function splitSentences(text) {
    const sentenceRegex = /([.!?])\s+/g;
    const sentences = [];
    let lastIndex = 0;

    text.replace(sentenceRegex, (match, punctuation, offset) => {
      const sentence = text.slice(lastIndex, offset + punctuation.length).trim();
      if (sentence) {
        if (sentence.length < 15) {
          if (sentences.length > 0) {
            sentences[sentences.length - 1] += " " + sentence;
          } else {
            sentences.push(sentence);
          }
        } else {
          sentences.push(sentence);
        }
      }
      lastIndex = offset + punctuation.length;
      return match;
    });

    const remainingText = text.slice(lastIndex).trim();
    if (remainingText) {
      sentences.push(remainingText);
    }

    return sentences;
  }

  const handleScriptSubmit = async (index) => {
    const step = steps[index];
    const script = step.script;
    const sentences = splitSentences(script).filter((sentence) => sentence.trim() !== "");

    const newSentences = !editing
      ? sentences.map((sentence) => ({
        sentence: sentence.trim(),
        notepadData: null,
        boardDataAdded: false,
      }))
      : sentences.map((sentence, i) => {
        const existingData = step.boardData?.[i];
        return {
          sentence: sentence.trim(),
          notepadData: existingData?.notepadData || null,
          boardDataAdded: existingData?.boardDataAdded || false,
        };
      });

    const scriptData = convertData(steps);

    const missingFields = [];

    if (!scriptData.steps[index].script?.trim()) {
      missingFields.push("Script");
    }
    if (!scriptData.steps[index].stepTitle?.trim()) {
      missingFields.push("Title");
    }
    if (!scriptData.steps[index].type?.trim()) {
      missingFields.push("Category");
    }

    if (scriptData.steps[index].type === "Product Script" || scriptData.steps[index].type === "Intro") {
      if (!scriptData.steps[index].buttonText?.trim()) {
        missingFields.push("Button Text");
      }
    }

    if (missingFields.length > 0) {
      alert(`Please fill the following required fields:\n\n- ${missingFields.join("\n- ")}`);
      return;
    }

    setSteps((prev) =>
      prev.map((step, i) =>
        i === index
          ? { ...step, submitted: true, boardData: newSentences }
          : step
      )
    );

    try {
      if (dealId?.length) {
        const updatedresponse = await apiFetcher(`/int-multi-stepper/${dealId}`, "PATCH", scriptData);
      } else {
        const response = await apiFetcher("/int-multi-stepper", "POST", scriptData);
        if (selectedDealer) {
          dispatch(updatemultiStepProcessId({ multiStepProcessId: selectedDealer }));
          savemultiStepProcessId(selectedDealer);
        }
        if (response && response._id) {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("multiStepProcessId", response._id);
          navigate(`?${searchParams.toString()}`, { replace: true });
        }

      }
    } catch (error) {
      console.error("Error during final submit:", error);
    }
    Setediting(false);
    setEditingIndex(null);
    setOriginalStepData(null);
  };

  const handleUpdate = (index) => {
    setEditingIndex(index)
    Setediting(true)
    setOriginalStepData(steps[index])
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index ? { ...step, submitted: false } : step
      )
    );
  };

  const handleDelete = async (index) => {
    setSteps((prev) => prev.filter((_, i) => i !== index));
    const scriptData = convertData(steps.filter((_, i) => i !== index));

    try {
      if (dealId?.length) {
        const updatedresponse = await apiFetcher(`/multi-stepper/${dealId}`, "PATCH", scriptData)
        console.log('updated', updatedresponse)
      }
    } catch (error) {
      console.error("Error during final submit:", error);
    }
  };

  const handleCategoryChange = (index, value) => {
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index
          ? {
            ...step,
            category: value,
            coreFeature: value === "Product Script" ? "" : undefined,
          }
          : step
      )
    );
  };

  const handleExtraTextChange = (index, field, value) => {
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index
          ? {
            ...step,
            [field]: value,
          }
          : step
      )
    );
  };


  const convertData = (originalData) => {
    const steps = originalData.map((item) => {
      const commonData = {
        stepTitle: item.title,
        script: item.script,
        type: item.category,
        corsText: item.coreFeature,
        price: item.price,
        priceTax: item.priceTax,
        priceShow: item.priceShow,
        buttonText: item?.buttonText,
        dealershipId: selectedDealer
      };

      const notepadContents = item.boardData
        .filter((boardItem) => boardItem.notepadData)
        .map((boardItem) => ({
          heading: boardItem.notepadData?.heading,
          subHeading: boardItem.notepadData?.subHeading,
          sentence: boardItem.notepadData?.content,
          isButton: boardItem?.notepadData?.isButton,
          buttonText: boardItem?.notepadData?.buttonText,
          images: boardItem.notepadData?.images?.map((img) => ({
            text: img.imgTitle,
            image: img.image,
          })),
          key: boardItem?.sentence,
          boardDataAdded: boardItem?.boardDataAdded
        }));

      return {
        ...commonData,
        notepadContents,
      };
    });

    return {
      steps,
      aiPrompt: promptInput,
      dealershipId: selectedDealer,
    };
  };

  const handleFinalSubmit = async () => {
    setSubmitting(true)
    const scriptData = convertData(steps);
    try {
      if (dealId?.length) {
        const updatedresponse = await apiFetcher(`/int-multi-stepper/${dealId}`, "PATCH", scriptData)
        console.log('updated', updatedresponse)
      }
      else {
        const response = await apiFetcher(`/int-multi-stepper`, "POST", scriptData);
        if (response && response._id) {
          dispatch(updatemultiStepProcessId({ multiStepProcessId: response._id }));
          savemultiStepProcessId(response?._id)
        }
      }
      navigate("/pitch-dealership");
    } catch (error) {
      console.error("Error during final submit:", error);
    }
    finally {
      setSubmitting(false)
    }
  };

  const handleContextMenu = (e, index) => {
    e.preventDefault();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      index: index,
    });
  }

  useEffect(() => {
    const handleClickOutside = () => {
      if (contextMenu.visible) {
        setContextMenu((prev) => ({ ...prev, visible: false }));
      }
    };
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [contextMenu.visible]);

  const stepLabels = [
    { label: "Manage Steps" },
    { label: "Manage Prompt" },
  ];

  const menuVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  }

  const handleCancel = (index) => {
    if (editing) {
      if (editingIndex !== null && originalStepData) {
        setSteps((prevsteps) => {
          return prevsteps.map((step, index) => {
            if (editingIndex === index) {
              return { ...originalStepData, submitted: true }
            }
            else {
              return step
            }
          })
        })
      }
    }
    else {
      let lastStepItem = steps?.[steps.length - 1];
      let clearedStepItem = Object.keys(lastStepItem).reduce((acc, key) => {
        let value = lastStepItem[key];

        if (key === "category") {
          acc[key] = value
        }
        else if (typeof value === "string") acc[key] = "";
        else if (typeof value === "number") acc[key] = value
        else if (typeof value === "boolean") acc[key] = false;
        else if (Array.isArray(value)) acc[key] = [];
        else if (typeof value === "object" && value !== null) acc[key] = {};
        else acc[key] = null;

        return acc;
      }, {});
      setSteps((prevsteps) => {
        return prevsteps.map((step, i) => {
          if (i === index) {
            return clearedStepItem;
          } else {
            return step
          }
        })
      })
    }
    Setediting(false)
    setEditingIndex(null)
    setOriginalStepData(null)
  }

  const stopPropagation = (e) => {
    e.stopPropagation();
  };






  // Fetch dealers
  const fetchDealers = async () => {
    try {
      setLoading(true);
      const response = await apiFetcher("/int-dealerships");
      console.log(response);
      setDealers(response); // Store fetched dealers in state
      setLoading(false);
    } catch (error) {
      console.error(error.errorMessage);
      setError("An error occurred while fetching users");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchDealers();
  }, []);


  if (loading) return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <TailSpin height="80" width="80" color="#4fa94d" ariaLabel="loading" />
    </div>
  );
  if (error) return <p>{error}</p>;




  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <TailSpin height="80" width="80" color="#4fa94d" ariaLabel="loading" />
      </div>
    );
  }

  return (
    <div className={styles.container}>

      <div>




        {/* Display selected dealer details (optional) */}

        <div>
          {/* 
          <p>
            <strong>{dealers.find(d => d._id === selectedDealer)?._id}</strong>
          </p> */}


          <div className={styles.stepperContainer}>
            <Stepper steps={stepLabels} activeStep={currentStep - 1} />
            <div className={styles.labelsContainer}>
              {stepLabels.map((e, index) => (
                <p key={index} className={styles.stepLabel}>{e.label}</p>
              ))}
            </div>
          </div>

          {currentStep === 1 && (
            <div>
              <header className={styles.header}>
                <div className="flex justify-end mb-4">
                  {steps.length > 0 && (<button
                    onClick={handleCopyAllData}
                    className="flex items-center justify-end gap-2 px-4 py-2 bg-green-500 text-white rounded-lg shadow-md hover:bg-green-600 mr-2"
                  >
                    <DocumentDuplicateIcon className="w-5 h-5" /> Copy All Data
                  </button>)}
                  <button
                    onClick={handlePasteData}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600"
                  >
                    <ClipboardIcon className="w-5 h-5" /> Paste Data
                  </button>
                </div>
              </header>

              <div className="flex flex-col items-center gap-4 p-4 bg-gray-50 rounded-2xl shadow-md w-full max-w-sm mx-auto">
                <label
                  htmlFor="logo-upload"
                  className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-100"
                >
                  {selectedImage ? (
                    <img
                      src={selectedImage.preview}
                      alt="Preview"
                      className="w-full h-full object-contain rounded-lg"
                    />
                  ) : (
                    <div className="flex flex-col items-center">
                      <p className="text-sm text-gray-600">Click to upload a logo</p>
                      <p className="text-xs text-gray-400">Supports PNG, JPG, JPEG</p>
                    </div>
                  )}
                  <input
                    id="logo-upload"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                </label>

                {selectedImage && (
                  <button
                    onClick={handleRemoveImage}
                    className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                  >
                    Remove Image
                  </button>
                )}
              </div>
              <div className="flex justify-end items-center mt-4">





                <div>
                  <select
                    id="dealer"
                    value={selectedDealer}
                    disabled={true}
                    className="block w-21 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  >
                    <option value="">-- Select a Dealer --</option>
                    {dealers?.map((dealer) => (
                      <option key={dealer._id} value={dealer._id}>
                        {dealer.dealershipName}
                      </option>
                    ))}
                  </select>

                  {selectedDealer && (
                    <button
                      onClick={handleAddAccordion}
                      className="flex items-center mt-4 gap-2 px-10 py-1 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 active:bg-blue-700 transition-all"
                    >
                      Add Step <FaPlus />
                    </button>
                  )}
                </div>
              </div>
              <div className={styles.accordion}>
                {steps.map((step, index) => (
                  <div key={index} onContextMenu={(e) => handleContextMenu(e, index)} className={styles.accordionItem}>
                    <div
                      className={styles.accordionHeader}
                      onClick={() => handleToggleAccordion(index)}
                    >

                      <input
                        type="text"
                        value={step.title}
                        maxLength={25}
                        onChange={(e) => handleTitleChange(index, e.target.value)}
                        className={styles.accordionTitleInput}
                        placeholder={step.placeholder}
                        onClick={stopPropagation}
                      />
                      <div className={styles.accordionSelectBody}>
                        <select
                          value={step.category}
                          onChange={(e) =>
                            handleCategoryChange(index, e.target.value)
                          }
                          className={styles.categoryDropdown}
                          onClick={stopPropagation}
                        >
                          <option value="">Select Category</option>
                          {categories.map((category) => (
                            <option key={category} value={category}>
                              {category}
                            </option>
                          ))}
                        </select>

                        <span className={styles.accordionToggle}
                        >
                          {activeIndex === index ? (
                            <FaChevronUp />
                          ) : (
                            <FaChevronDown />
                          )}
                        </span>
                      </div>
                    </div>
                    {activeIndex === index && (
                      <div className={styles.accordionBody}>

                        {!step.submitted ? (
                          <>
                            <textarea
                              placeholder="Enter script..."
                              value={step.script}
                              onChange={(e) =>
                                setSteps((prev) =>
                                  prev.map((item, i) =>
                                    i === index
                                      ? { ...item, script: e.target.value }
                                      : item
                                  )
                                )
                              }
                              className={styles.textarea}
                            ></textarea>

                            {!["Summary Script", "Final Script"].includes(step.category) && (
                              <>
                                <label className={styles.lable}>Enter the Button text </label>
                                <input
                                  placeholder="Enter Button text"
                                  value={step.buttonText || ""}
                                  required
                                  onChange={(e) =>
                                    handleExtraTextChange(
                                      index,
                                      "buttonText",
                                      e.target.value
                                    )
                                  }
                                  className={styles.btnText}
                                />
                              </>
                            )}

                            {step.category === "Product Script" && (
                              <>
                                <br /><label className={styles.lable}>Price</label>
                                <input
                                  placeholder="Enter Button text"
                                  value={step.price || ""}
                                  required
                                  onChange={(e) =>
                                    handleExtraTextChange(
                                      index,
                                      "price",
                                      e.target.value
                                    )
                                  }
                                  type="number"
                                  className={styles.btnText}
                                /> <br />

                                <label className={styles.lable}>Feature</label>
                                <textarea
                                  //     maxLength={50}
                                  placeholder="Feature"
                                  className={styles.textarea}
                                  value={step.coreFeature || ""}
                                  onChange={(e) =>
                                    handleExtraTextChange(
                                      index,
                                      "coreFeature",
                                      e.target.value
                                    )
                                  }
                                ></textarea>

                              </>
                            )}

                            <div className={styles.addButtonContainer}>
                              <button
                                onClick={() => handleScriptSubmit(index)}
                                className={styles.submitButton}
                              >
                                Submit
                              </button>

                              {
                                <button
                                  onClick={() => handleCancel(index)}
                                  className={styles.cancelBtn}
                                >
                                  cancel
                                </button>}
                            </div>
                          </>
                        ) : (
                          <div>
                            <div className={styles.scriptText}> <label>Script:</label> <br />{step.script}</div>
                            {step.category === "Product Script" && (
                              <>
                                <div className={styles.scriptText}>
                                  <label>Price:</label> <br /> {step.price}</div>
                                <div className={styles.scriptText}>
                                  <label>Feature:</label> <br /> {step.coreFeature}</div>


                              </>
                            )}
                            {!["Summary Script", "Final Script"].includes(step.category) && (
                              <>
                                <div className={styles.btnText}>
                                  <label>Button Text:</label> <br /> {step.buttonText}
                                </div>
                              </>
                            )}
                            <div className={styles.steperbuttonContainer}>
                              <button
                                onClick={() => handleUpdate(index)}
                                className={styles.updateButton}
                              >

                                <FaEdit />
                              </button>
                              <button
                                onClick={() => handleDelete(index)}
                                className={styles.deleteButton}
                              >
                                <MdDelete />
                              </button>
                            </div>

                            {steps[activeIndex]?.category === "Summary Script" || steps[activeIndex]?.category === "Final Script" ? (null) :
                              (
                                <TableComponent
                                  activeIndex={activeIndex}
                                  currentIndex={currentIndex}
                                  setCurrentIndex={setCurrentIndex}
                                  onActionClick={index + 1}
                                  formData={formData}
                                  setFormData={setFormData}
                                  selectedSentence={selectedSentence}
                                  setSelectedSentence={setSelectedSentence}
                                  tableIndex={tableIndex}
                                  setTableIndex={setTableIndex}
                                  steps={steps}
                                  setSteps={setSteps}
                                  editIndex={editIndex}
                                  setEditIndex={setEditIndex}
                                />
                              )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}

                <AnimatePresence>
                  {contextMenu.visible && (
                    <motion.div
                      className="fixed z-50 w-56 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden"
                      style={{ top: contextMenu.y, left: contextMenu.x }}
                      initial="hidden"
                      animate="visible"
                      exit="hidden"
                      variants={menuVariants}
                      transition={{ duration: 0.3 }}
                    >
                      <ul className="py-2">
                        <li className="flex items-center justify-between">
                          <button
                            onClick={() => {
                              handleDelete(contextMenu.index)
                              setContextMenu((prev) => ({ ...prev, visible: false }));
                            }}
                            className="w-full text-left px-4 py-2 flex items-center space-x-3 hover:bg-indigo-50 focus:outline-none focus:bg-indigo-50 transition-colors duration-150"
                          >
                            <span><TrashIcon className="w-4 h-4 text-gray-400" /></span>
                            Delete accordion
                          </button>
                        </li>
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
              {isShowNext &&
                (
                  <div className={styles.buttonContainerB}>
                    <button onClick={handleNextStep} className={styles.nextButton}>
                      <p>Manage Your Prompt</p> <MdNavigateNext />
                    </button>
                  </div>
                )
              }
            </div>
          )}

          {currentStep === 2 && (
            <div>
              <header className={styles.header}>
              </header>
              <div className="w-100 flex justify-center">
                <div className="flex flex-col items-center justify-end p-6 bg-gray-100 rounded-xl shadow-md w-96 mb-3">
                  <label
                    htmlFor="pdf-upload"
                    className="cursor-pointer bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition"
                  >
                    Choose a PDF
                  </label>
                  <input
                    id="pdf-upload"
                    type="file"
                    accept="application/pdf"
                    className="hidden"
                    onChange={handleFileChange}
                  />

                  <div
                    className="mt-4 p-6 border-2 border-dashed border-gray-400 rounded-lg text-center bg-white w-full"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <p className="text-gray-500">Drag & Drop your PDF here</p>
                  </div>

                  {selectedFile && (
                    <div className="mt-4 bg-gray-200 p-3 rounded-lg w-full text-center">
                      <p className="text-gray-700">{selectedFile.name}</p>
                    </div>
                  )}
                </div>
              </div>
              <textarea
                rows="10"
                cols="50"
                value={promptInput}
                onChange={handleInputChange}
                placeholder="Type your prompt here"
                style={{ width: "100%", height: "450px" }}
                className={styles.textarea}
              />
              <div className={styles.buttonContainerB}>
                <button onClick={handlePrevStep} className={styles.prevButton}>
                  <GrFormPrevious /><p>Back</p>
                </button>
                <button disabled={submitting} onClick={handleFinalSubmit} className={styles.submitButton}>
                  {submitting ? "Submitting..." : "Final Submit"}
                </button>
              </div>
            </div>
          )}
        </div>

      </div>

    </div>
  );
};

export default StepperForm;